import { injectable } from '~/container'
import { GeoCoordinates, GeolocationError } from './schema'
import { GeolocationService } from './services'

@injectable()
export class NavigatorGeolocationService implements GeolocationService {
  async getCoordinates(): Promise<GeoCoordinates | GeolocationError> {
    try {
      const cooridnates: GeolocationPosition = await this.getNavigatorPromise()
      return {
        lat: parseFloat(cooridnates.coords.latitude.toFixed(4)),
        lng: parseFloat(cooridnates.coords.longitude.toFixed(4)),
      }
    } catch (err) {
      const errorCode = this.mapGeolocationError(
        err as GeolocationPositionError,
      )
      const error = new Error(`Geolocation failed: ${errorCode}`)
      error.name = 'GeolocationError'
      // Attach additional context for debugging
      ;(error as any).code = errorCode
      ;(error as any).originalError = err
      throw error
    }
  }

  getNavigatorPromise(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject)
    })
  }

  mapGeolocationError({ code }: GeolocationPositionError): GeolocationError {
    const geolocationErrors = {
      1: 'denied',
      2: 'unavailable',
      3: 'timeout',
    }
    return geolocationErrors[code]
  }
}
